import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'

/**
 * Full-page OAuth error view: icon, localized title, the provided error
 * message, and a link back to the login page.
 */
export function ErrorState({ message }: { message: string }) {
  const { t } = useTranslation()
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center space-y-6">
        <div className="mx-auto h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
          <AlertCircle className="h-7 w-7 text-destructive" />
        </div>
        <div>
          <h1 className="font-serif text-2xl font-bold text-destructive">
            {t('auth.oauth_error_title')}
          </h1>
          <p className="text-muted-foreground mt-2 text-sm">{message}</p>
        </div>
        <Link
          to="/login"
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90 transition-colors"
        >
          {t('auth.oauth_back_to_login')}
        </Link>
      </div>
    </div>
  )
}
